// First day of the game (October 11, 2026), as midnight UTC of that date
export const startDate = Date.UTC(2026, 9, 11);
